// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from '@rails/ujs';
import Turbolinks from 'turbolinks';
import * as ActiveStorage from '@rails/activestorage';
import 'channels';

import '@popperjs/core';
import 'bootstrap';

import '../../assets/stylesheets/fontawesome.scss';
import '@fortawesome/fontawesome-free/scss/regular.scss';
import '@fortawesome/fontawesome-free/scss/solid.scss';
import '@fortawesome/fontawesome-free/scss/brands.scss';
import 'react-quill/dist/quill.snow.css';

import initFormAccountSelect from '../components/form-account-select';
import initPopovers from '../components/popovers';
import initAccountLogo from '../components/account-logo';
import initQuill from '../components/quill';
import initAutoSubmitInput from '../components/auto-submit-input';
import initClipboard from '../components/clipboard';

Rails.start();
Turbolinks.start();
ActiveStorage.start();

document.addEventListener('turbolinks:load', () => {
  initPopovers();
  initFormAccountSelect();
  initAccountLogo();
  initQuill();
  initAutoSubmitInput();
  initClipboard();
});
